<template>
	<section class="judges">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="judges__wrapper">
						<router-link
							:to="{name: 'Judge', params: { id: judge.id }, query: { page: $store.state.judges.judges.currentPage }}"
							v-for="judge in $store.state.judges.judges.results"
							:key="judge.id"
							class="judges__stripe-wrapper"
						>
							<div class="judges__name">
								<img class="judges__icon" src="/static/img/hammer.svg" alt="">
								<span>
									{{ judge.full_name }}
									<span v-if="judge.nationality">
										({{ judge.nationality }})
									</span>
								</span>
							</div>
							<div class="judges__stars">
								<span v-if="judge.average_score" class="judges__score">
									{{ getScore(judge.average_score) }}
								</span>
								<span v-if="!judge.average_score" class="judges__score judges__score--zero">
									{{$t('judges.ratings')}}
								</span>
								<img v-for="i in 6" v-if="judge.average_score && i <= getScore(judge.average_score)" class="judges__star" src="/static/img/star-gold.svg" alt="">
								<img v-for="i in 6" v-if="judge.average_score && i > getScore(judge.average_score)" class="judges__star" src="/static/img/star-empty.svg" alt="">
							</div>
							<div class="judges__reviews">
								<span>{{judge.comments_count}} {{$t('judges.reviews')}}</span>
							</div>
						</router-link>
						<h3 v-if="!$store.state.judges.judges.results[0]">{{$t('noResults')}}</h3>
					</div>
					<PaginationComponent :count="$store.state.judges.judges.count"
										 :currentPage="$store.state.judges.judges.currentPage"
										 @pageChanged="fetchJudges">
					</PaginationComponent>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import PaginationComponent from '../PaginationComponent'
	import { mapActions } from 'vuex'

	export default {
		components: {
			PaginationComponent
		},
		data () {
			return {
				judges: []
			}
		},
		methods: {
			...mapActions(['fetchJudges']),
			getScore (score) {
				return Math.round(score)
			}
		},
		created () {
			this.fetchJudges()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.judges {
		padding-top: 40px;
		background-color: $gray-light;
		&__stripe-wrapper {
			display: flex;
			align-items: center;
			width: 100%;
			height: 70px;
			margin-bottom: 25px;
			text-decoration: none;
			&:nth-of-type(10) {
				margin-bottom: 40px;
			}
		}
		&__name {
			height: 100%;
			display: flex;
			align-items: center;
			background-color: $silver;
			font-family: $lato-bold;
			font-size: 16px;
			width: 655px;
			padding-left: 25px;
			color: $black;
		}
		&__icon {
			margin-right: 15px;
		}
		&__stars {
			height: 100%;
			width: 290px;
			background-color: $fav;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		&__reviews {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			width: 195px;
			background-color: #fff;
			color: $black;
		}
		&__score {
			font-family: $lato-bold;
			font-size: 20px;
			color: $gold-score;
			width: 50px;
			&--zero {
				width: 100%;
			}
		}
		&__star {
			margin-right: 6px;
		}
	}

	.col-3 {
		&--flex {
			display: flex;
			align-items: center;
		}
	}

	@media (max-width: 991.98px) {
		.judges {
			/*padding-top: 35px;*/
			background-color: $gray-light;
			&__stripe-wrapper {
				flex-flow: column;
				width: 100%;
				height: auto;
				margin-bottom: 25px;
				text-decoration: none;
			}
			&__name {
				font-size: 14px;
				width: 100%;
				padding: 20px 15px 15px;
			}
			&__stars {
				min-height: 45px;
				width: 100%;
				background-color: $fav;
				padding-top: 20px;
			}
			&__reviews {
				padding: 15px 0 20px;
				width: 100%;
				background-color: $fav;
			}
			&__score {
				font-family: $lato-bold;
				font-size: 20px;
				color: $gold-score;
				width: 50px;
				&--zero {
					width: 100%;
				}
			}
			&__star {
				margin-right: 6px;
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {

	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {

	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/JudgesList/JudgesComponent.vue